export function menuIsEnabled(menu, config) {
    if (menu === true) {
        return true;
    }
    else if (menu) {
        const options = menu(config);
        return Array.isArray(options) ? !!options.length : options;
    }
    return false;
}
//# sourceMappingURL=menu.js.map